import { OutvioCode } from '../Interfaces';

const INCIDENT_STATUS_TEXT_KEYS: { [key in OutvioCode]?: string } = {
  [OutvioCode.BAD_ADDRESS]: 'general.status.BAD_ADDRESS',
  [OutvioCode.CANCELLED]: 'general.status.CANCELLED',
  [OutvioCode.DAMAGED]: 'general.status.DAMAGED',
  [OutvioCode.DELAYED]: 'general.status.DELAYED',
  [OutvioCode.DESTROYED]: 'general.status.DESTROYED',
  [OutvioCode.IMPORTANT_INCIDENTS]: 'general.status.IMPORTANT_INCIDENTS',
  [OutvioCode.LOST]: 'general.status.LOST',
  [OutvioCode.MISSING_DOCUMENTATION]: 'general.status.MISSING_DOCUMENTATION',
  [OutvioCode.NOT_AT_HOME]: 'general.status.NOT_AT_HOME',
  [OutvioCode.OTHER_INCIDENTS]: 'general.status.OTHER_INCIDENTS',
  [OutvioCode.PARTIALLY_DELIVERED]: 'general.status.PARTIALLY_DELIVERED',
  [OutvioCode.REFUSED]: 'general.status.REFUSED',
  [OutvioCode.RETURN_TO_ORIGIN]: 'general.status.RETURNED_TO_ORIGIN',
  [OutvioCode.STOLEN]: 'general.status.STOLEN',
};

export const getIncidentStatusTextKey = (code: OutvioCode): string | undefined =>
  INCIDENT_STATUS_TEXT_KEYS[code];

export const toStepCase = (text: string): string => {
  const trimmed = text.trim();
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
};
